import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  titleNavigation: (<PortalMessage id='t.app.profile.settings.pointofsales.titleNavigation' defaultMessage='Lista punti vendita' />),
  close: (<PortalMessage id='t.app.profile.settings.pointofsales.close' defaultMessage='chiudi' />),
  sectionTitle: (<PortalMessage id='t.app.profile.settings.pointofsales.sectionTitle' defaultMessage='In questa sezione sono mostrate solo le transazioni dei seguenti punti vendita in quanto sono gli unici ad avere la componente terminale POS.' />),
  total: (<PortalMessage id='t.app.profile.settings.pointofsales.total' defaultMessage='Totale punti vendita' />),
  columnPV: (<PortalMessage id='t.app.profile.settings.pointofsales.columnPV' defaultMessage='Punto Vendita' />),
  columnTypology: (<PortalMessage id='t.app.profile.settings.pointofsales.columnTypology' defaultMessage='Tipologia' />),
  columnCode: (<PortalMessage id='t.app.profile.settings.pointofsales.columnCode' defaultMessage='Codice' />),
  columnAddress: (<PortalMessage id='t.app.profile.settings.pointofsales.columnAddress' defaultMessage='Indirizzo' />)
}

export default formattedMessage
